import React from 'react';
import { useTranslation } from 'react-i18next';
import { change } from 'redux-form';
import { connect } from 'react-redux';

import { Typography } from '@material-ui/core';
import Button from '@material-ui/core/Button';

import CancelOutlinedIcon from '@material-ui/icons/CancelOutlined';

import { DropDown } from 'components';

import useStyles from './styles';

const SHORT_LANGUAGES_OBJ = {
  English: 'Eng',
  Norway: 'Nor'
};

const FULL_LANGUAGES_OBJ = {
  Eng: 'English',
  Nor: 'Norway'
};

const Header = ({
  title,
  cancelCallback,
  widgetForm,
  changeFormFieldValue,
  initialAvailableCurrencies,
  initialSelectedCurrency,
  setInitialSelectedCurrency,
  initialSelectedLanguage,
  setInitialSelectedLanguage,
  initialAvailableLanguages,
  logo
}) => {
  const classes = useStyles();
  const [t, i18n] = useTranslation();

  const isWidgetForm = !!Object.keys(widgetForm || {}).length;

  const currency = isWidgetForm
    ? widgetForm.values.currency || initialSelectedCurrency
    : initialSelectedCurrency;
  const availableCurrencies =
    isWidgetForm && widgetForm.values.availableCurrencies
      ? widgetForm.values.availableCurrencies
      : initialAvailableCurrencies;

  const languages =
    isWidgetForm && widgetForm.values.languages
      ? widgetForm.values.languages
      : initialAvailableLanguages;
  const selectedLanguage =
    (isWidgetForm && widgetForm.values.selectedLanguage) ||
    initialSelectedLanguage;

  return (
    <div className={classes.wrapper}>
      <div className={classes.titleSection}>
        {logo && !!logo.length && (
          <img src={logo} alt="Logo" className={classes.logo} />
        )}
        {!!title && <Typography variant="h1">{t(title)}</Typography>}
      </div>
      <div className={classes.actions}>
        <div className={classes.dropdowns}>
          {languages && languages.length > 1 && (
            <div className={classes.language}>
              <DropDown
                input={{
                  value: SHORT_LANGUAGES_OBJ[selectedLanguage],
                  onChange: e => {
                    i18n.changeLanguage(FULL_LANGUAGES_OBJ[e.target.value]);
                    if (!widgetForm || !widgetForm.values.selectedLanguage) {
                      setInitialSelectedLanguage(
                        FULL_LANGUAGES_OBJ[e.target.value]
                      );
                      return;
                    }
                    changeFormFieldValue(
                      'selectedLanguage',
                      FULL_LANGUAGES_OBJ[e.target.value]
                    );
                  }
                }}
                inputBaseClass={classes.dropdownInputBase}
                selectRootClass={classes.currencySelectRoot}
                selectIconClass={classes.selectIcon}
                list={['Eng', 'Nor']}
                meta={{}}
              />
            </div>
          )}
          {availableCurrencies && (
            <DropDown
              input={{
                value: currency,
                onChange: e => {
                  if (!widgetForm || !widgetForm.values.currency) {
                    setInitialSelectedCurrency(e.target.value);
                    return;
                  }
                  changeFormFieldValue('currency', e.target.value);
                }
              }}
              inputBaseClass={classes.dropdownInputBase}
              selectRootClass={classes.selectRoot}
              selectIconClass={classes.selectIcon}
              list={availableCurrencies}
              meta={{}}
            />
          )}
        </div>
        <Button
          className={classes.button}
          onClick={() => cancelCallback && cancelCallback()}
          endIcon={<CancelOutlinedIcon className={classes.cancelIcon} />}
        >
          <Typography variant="body1" className={classes.cancel}>
            {t('Cancel')}
          </Typography>
        </Button>
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    widgetForm: state.form.widgetForm
  };
};

const mapDispatchToProps = dispatch => ({
  changeFormFieldValue: (field, value) => {
    dispatch(change('widgetForm', field, value));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);
